/** Small text helpers the Products and Library screens share, ported from the prototype's own. */

const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** A D1 time ("2026-10-01 10:48:22", UTC) as a Date. */
export const parseTime = (t: string) => new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(t) ? t : `${t.replace(" ", "T")}Z`);

/** "29 Sep", the prototype's short date. */
export const shortDate = (t: string) => {
  const d = parseTime(t);
  return Number.isNaN(d.getTime()) ? "" : `${d.getDate()} ${MON[d.getMonth()]}`;
};

/** Seconds as the prototype writes them: "22 s" or "5 min 01 s". */
export const mmss = (s: number) => {
  const v = Math.max(0, Math.round(s));
  return v < 60 ? `${v} s` : `${Math.floor(v / 60)} min ${String(v % 60).padStart(2, "0")} s`;
};

/** Money in micros as dollars and cents: "$0.10". */
export const dollars = (micros: number) => `$${(micros / 1_000_000).toFixed(2)}`;

/** The site's name from an address, the way the prototype shows sources: "natwallen.com". */
export function host(u: string): string {
  const m = String(u).match(/https?:\/\/(?:www\.)?([^/\s]+)/g);
  return m ? [...new Set(m.map((x) => x.replace(/https?:\/\/(www\.)?/, "")))].slice(0, 2).join(" · ") : String(u).slice(0, 70);
}

export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Up to two letters for a product's mark. */
export const initials = (n: string) =>
  String(n)
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

/** The first sentence of a text, at most about 170 characters. Why: a full stop inside a quote is not the end of the sentence. */
export function firstLine(t: string): string {
  const l = String(t)
    .split("\n")
    .map((x) => x.replace(/^\s*-\s+/, "").trim())
    .filter(Boolean);
  let f = l[0] ?? "";
  const re = /[.!?](?=\s)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(f))) {
    const head = f.slice(0, m.index + 1);
    const q = (head.match(/"/g) ?? []).length;
    const o = (head.match(/“/g) ?? []).length;
    const c = (head.match(/”/g) ?? []).length;
    if (m.index >= 40 && q % 2 === 0 && o === c) {
      f = head;
      break;
    }
  }
  return f.length > 170 ? `${f.slice(0, 167).trim()}...` : f;
}

/** How many bullet points a text has, at least one. */
export const bullets = (t: string) => String(t).split("\n").filter((x) => /^\s*-\s+/.test(x)).length || 1;

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
